import React from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import Logger from 'observability/Logger';

const LOG = new Logger('withBootstrapSitekey');
const ERROR_MESSAGE = 'Error loading captcha';

/**
 * @param {React} Component
 * @param {string} [bootstrapPath]
 * @return {React}
 */
export default function withBootstrapSitekey(Component, bootstrapPath = 'recaptcha2Sitekey') {
    const recaptcha2Sitekey = getBootstrap().get(bootstrapPath);
    const recaptchaGoogleCloudEnabled = getBootstrap().get('flags.recaptchaGoogleCloudEnabled') || false;
    const recaptchaGoogleCloudKey = getBootstrap().get('recaptchaGoogleCloudKey');

    const siteKey = recaptchaGoogleCloudEnabled ? recaptchaGoogleCloudKey : recaptcha2Sitekey;

    return (props) => {
        if (!siteKey) {
            if (!__TESTING__) {
                LOG.error('Error: Missing reCAPTCHA sitekey');
            }
            return <p>{ERROR_MESSAGE}</p>;
        }
        return <Component sitekey={siteKey} recaptchaGoogleCloudEnabled={recaptchaGoogleCloudEnabled} {...props} />;
    };
}
